import * as React from 'react';

var _path, _g, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFastTrackChosenDuotone24 = function SvgFastTrackChosenDuotone24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.69 10.832a.4.4 0 0 0-.358-.214l-10.042.106a.4.4 0 0 0-.396.4v7.518c0 .22.179.4.4.4h.812a1.487 1.487 0 0 1 2.816 0h7.093a1.487 1.487 0 0 1 2.816 0h.688a.4.4 0 0 0 .4-.4v-1.715a.4.4 0 0 0-.221-.358l-.89-.444a1.6 1.6 0 0 1-.704-.689l-2.415-4.604zm3.03 9.41a1.487 1.487 0 0 1-2.594 0h-7.314c.018-.034.036-.068.052-.103-.235.508-.751.86-1.35.86a1.484 1.484 0 0 1-1.297-.757h-.923a1.6 1.6 0 0 1-1.6-1.6v-7.518a1.6 1.6 0 0 1 1.583-1.6l10.042-.106a1.6 1.6 0 0 1 1.434.857l2.415 4.604a.4.4 0 0 0 .175.172l.891.444a1.6 1.6 0 0 1 .886 1.432v1.715a1.6 1.6 0 0 1-1.6 1.6h-.799zm-.81-.725c0 .263-.215.482-.486.482s-.487-.219-.487-.482.215-.481.487-.481.486.218.486.481zm-9.91 0c0 .264-.214.482-.486.482s-.486-.218-.486-.481.215-.482.486-.482.487.219.487.482z",
    clipRule: "evenodd",
    fill: "currentColor",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.407 11.044H.6M5.407 12.754H3.174M5.407 14.465h-.516"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "secondary-color",
    d: "M11.72 0A6.727 6.727 0 0 0 5 6.72a6.728 6.728 0 0 0 6.72 6.72 6.729 6.729 0 0 0 6.72-6.72A6.728 6.728 0 0 0 11.72 0z",
    clipRule: "evenodd",
    fill: "currentColor",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.88 6.72 2.88 2.4 4.8-5.28",
    stroke: "#fff",
    strokeLinecap: "round"
  })));
};

var FastTrackChosenDuotone24Svg = SvgFastTrackChosenDuotone24;

export { FastTrackChosenDuotone24Svg as default };
//# sourceMappingURL=FastTrackChosenDuotone24.svg.js.map
